import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import Layout from 'antd/lib/layout';

const { Header } = Layout;

export const Navbar = styled(Header)`
  background-color: #152E4D;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  height: 64px;
  line-height: 1;
`;

export const NavSection = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  min-width: 0;
`;

export const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const Logo = styled.img`
  display: block;
  height: 34px;
  width: auto;
`;

export const Link = styled(NavLink)`
  color: rgba(255, 255, 255, 0.92);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.78rem 1.55rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 400;
  opacity: .72;
  line-height: 1;
  transition: background-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease, color 0.15s ease;

  &:hover {
    color: #fff;
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.06);
  }

  &.active {
    color: #fff;
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.09);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
  }
`;
